import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type {
  BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData,
  BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostError,
  BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostResponse,
} from '../../generated/types.gen';
import { multipartPost } from '../../utils';

export type BulkInviteCsvMutationVariables =
  BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData['path'] &
    BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostData['body'];

export type BulkInviteCsvMutation = BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostResponse;

export const useBulkInviteCsvMutation = <
  TError = BulkInviteCsvV1OrganizationsOrganizationIdUsersBulkInviteCsvPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<BulkInviteCsvMutation, TError, BulkInviteCsvMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<BulkInviteCsvMutation, TError, BulkInviteCsvMutationVariables, TContext>({
    mutationKey: ['BulkInviteCsv'],
    mutationFn: ({ organization_id, file, role, scope_type, scope_ids }: BulkInviteCsvMutationVariables) =>
      multipartPost<BulkInviteCsvMutation>(
        '/v1/organizations/{organization_id}/users/bulk-invite/csv',
        file,
        { organization_id },
        { role, scope_type, scope_ids },
      ),
    ...options,
  });
};
